import { Component, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FORMAT_TIME } from '@navfleet/client/shared/constants/app';
import moment from 'moment';
import { map, timer } from 'rxjs';

const MINUTE_MS = 60_000;

@Component({
    selector: 'fl-top-menu-clock',
    templateUrl: './top-menu-clock.component.html',
    styleUrl: './top-menu-clock.component.scss',
})
export class TopMenuClockComponent {
    public readonly timezone = input<string>();

    protected readonly time = toSignal(
        timer(MINUTE_MS - (Date.now() % MINUTE_MS), MINUTE_MS).pipe(map(() => moment().format(FORMAT_TIME))),
        { initialValue: moment().format(FORMAT_TIME) }
    );
}
